import VerificationStatisticTable from './VerificationStatisticTable';

export default VerificationStatisticTable;
